export interface NotificationEntity {
	id: string;
	userEntityId: string;
	title: string;
	message: string;
	type: NotificationType;
	category: NotificationCategory;
	audience: NotificationAudience;
	createdAt: Date;
	lastUpdatedAt: Date;
	isRead: boolean;
	actionLink?: string;
	actionText?: string;
	additionalData?: { [key: string]: string };
	expiryDate?: Date;
	priority: NotificationPriority;
}

export enum NotificationType {
	Info = 0,
	Success = 1,
	Warning = 2,
	Error = 3,
	AdminAlert = 4,
	JobUpdate = 5,
	ApplicationUpdate = 6,
	Deadline = 7,
	Quote = 8,
	Welcome = 9,
	ResumeReminder = 10,
	StatusUpdate = 11,
	ReferralAdminReview = 12,
	ReferralReferrerChat = 13,
	ReferralApplicationChat = 14,
	JobAdminReview= 15,
}

export enum NotificationCategory {
	General = 0,
	JobRelated = 1,
	AdminAlert = 2,
	Shortlisting = 3,
	Deadline = 4,
	System = 5,
	Profile = 6,
	Motivation = 7,
	Referral = 8,
}

export enum NotificationAudience {
	All = 0,
	AdminOnly = 1,
	StudentOnly = 2,
	ProfessionalOnly = 3,
}

export enum NotificationPriority {
	Low = 0,
	Normal = 1,
	High = 2,
	Urgent = 3,
}

export const notificationTypeToString = (type: NotificationType): string => {
	switch (type) {
		case NotificationType.Info:
			return "info";
		case NotificationType.Success:
			return "success";
		case NotificationType.Warning:
			return "warning";
		case NotificationType.Error:
			return "error";
		case NotificationType.AdminAlert:
			return "error";
		default:
			return "info";
	}
};

export const getPriorityColor = (priority: NotificationPriority): string => {
	switch (priority) {
		case NotificationPriority.Urgent:
			return "error";
		case NotificationPriority.High:
			return "warning";
		case NotificationPriority.Normal:
			return "info";
		case NotificationPriority.Low:
			return "success";
		default:
			return "info";
	}
};
